import React from 'react';

import { twilight } from 'lib/v2/colors';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import MuiLinearProgress from '@mui/material/LinearProgress';

const getColor = (value) => {
  // const hue = (value / 440) * 100;
  const hue = Math.floor(value);
  const lightness = Math.floor((value / 100) * -15) + 55;
  return `hsl(${hue}, 85%, ${lightness}%)`;
};

const StyledLinearProgress = styled(MuiLinearProgress, {
  shouldForwardProp: (prop) => prop !== 'barColor',
})(({ barColor }) => ({
  height: 10,
  borderRadius: 5,
  '& .MuiLinearProgress-bar': {
    borderRadius: 5,
    background: barColor,
  },
}));

const ProgressBar = ({ value, withLabel, color, staticColor }) => {
  if (!color) {
    color = staticColor ? twilight : getColor(value);
  }

  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <StyledLinearProgress
          variant="determinate"
          value={value}
          barColor={color}
          color="primary"
        />
      </Box>
      {withLabel && (
        <Box minWidth={35}>
          <Typography variant="body2" color="secondary">{`${Math.round(value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ProgressBar;
